var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("404 "+_vm._s(_vm.$t("error_page_404")))])
}
var staticRenderFns = []

export { render, staticRenderFns }